import React from 'react';
import { useIsMobile } from '../../../hooks/useIsMobile';
import ScienceSectionDesktop from './ScienceSectionDesktop';
import ScienceSectionMobile from './ScienceSectionMobile';

const ScienceSection = () => {
  const isMobile = useIsMobile();
  return isMobile ? <ScienceSectionMobile /> : <ScienceSectionDesktop />;
};

export default ScienceSection;
